const Flickity = () => { return import(/* webpackChunkName: 'flickity' */ './Flickity.vue'); };

export {
    Flickity,
};
